import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainDashboard", "list", "view", "3333", "4444", "5555", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `operations--products--clinics--financials--expenses--dashboard`
  }

  doExpensesDashboard() {
    var html = `<div class="row" data-${this.controllerName}-target="mainDashboard">
                  <div class="col-7 pr-1" data-${this.controllerName}-target="list" data-controller="operations--products--clinics--financials--expenses--index"></div>
                  <div class="col-5 pl-1" data-${this.controllerName}-target="view" data-controller="operations--products--clinics--financials--expenses--save
                                                                                                     operations--products--clinics--financials--expenses--show
                                                                                                     operations--products--clinics--financials--expenses--upload"></div>
                </div>`

    // this.getControllerByIdentifier("operations--products--clinics--financials--show--main").contentTarget.innerHTML = html
    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier(`operations--products--clinics--financials--show--main`).contentTarget.innerHTML = html)
    }).then(() => {

      console.log(controller.permission)
      controller.getControllerByIdentifier(`operations--products--clinics--financials--show--submenu`).dashboardToggleBtn(`DESPESAS`)
      controller.getControllerByIdentifier(`operations--products--clinics--financials--expenses--index`).permission = `medclinic_financial_expenses`
      controller.getControllerByIdentifier(`operations--products--clinics--financials--expenses--show`).permission = `medclinic_financial_expenses`
      controller.getControllerByIdentifier(`operations--products--clinics--financials--expenses--save`).permission = `medclinic_financial_expenses`
      controller.getControllerByIdentifier(`operations--products--clinics--financials--expenses--upload`).permission = `medclinic_financial_expenses`

      controller.getControllerByIdentifier(`operations--products--clinics--financials--expenses--index`).doIndexListHtml()
      controller.getControllerByIdentifier(`operations--products--clinics--financials--expenses--show`).doViewHtml()
    })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
